module.exports = __webpack_public_path__ + "static/assets/891f2b99ccbd73cc28d23f3e1f429de8.svg";